var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sequencer',{key:JSON.stringify(_vm.chapterJSON),attrs:{"jsonPayload":JSON.stringify(_vm.chapterJSON)},on:{"endGame":function($event){return _vm.endGame()}}})}
var staticRenderFns = []

export { render, staticRenderFns }